import { TenantContext } from '@/components';
import { SortDirection } from '@/components/Table/types';
import { infrastructuresRepo } from '@/constants/providers';
import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { InfrastructureCostKey } from './types';

type UseGetInfrastructureCostsByAutomationProps = {
  automationId: number;
  pageNumber?: number;
  filter?: string;
  sortBy?: string;
  sortOrder?: SortDirection;
};

export const useGetInfrastructureCostsByAutomation = ({
  automationId,
  pageNumber,
  filter,
  sortBy,
  sortOrder,
}: UseGetInfrastructureCostsByAutomationProps) => {
  const { currentSelectedTenant } = useContext(TenantContext);

  return useQuery(
    [
      ...InfrastructureCostKey.PAGE_BY_AUTOMATION(
        automationId,
        pageNumber,
        filter,
        sortBy,
        sortOrder,
      ),
      currentSelectedTenant?.id,
    ],
    () =>
      infrastructuresRepo.getInfrastructureCostsByAutomation(
        automationId,
        pageNumber,
        filter,
        sortBy,
        sortOrder,
      ),
    {
      cacheTime: 1000 * 60 * 100,
    },
  );
};
